import clsx from 'clsx'
import Balancer from 'react-wrap-balancer'

// wrap Balancer to remove type errors :( - @TODO - fix this ugly hack
const BalancerWrapper = (props) => <Balancer {...props} />

// loading placeholder animation for the chat line
export const LoadingChatLine = () => (
  <div className="flex lg:w-[629px] animate-pulse px-4 py-5 sm:px-6">
    <div className="flex flex-grow space-x-3">
      <div className="min-w-0 flex-1">
        <p className="font-large text-xxl text-gray-400">
          <a href="#" className="hover:underline">
            Annalese (AI)
          </a>
        </p>
        <div className="space-y-4 pt-4">
          <div className="grid grid-cols-3 gap-4">
            <div className="col-span-2 h-2 rounded bg-zinc-500"></div>
            <div className="col-span-1 h-2 rounded bg-zinc-500"></div>
          </div>
          <div className="h-2 rounded bg-zinc-500"></div>
        </div>
      </div>
    </div>
  </div>
)

// util helper to convert new lines to <br /> tags
const convertNewLines = (text) =>
  text.split('\n').map((line, i) => (
    <span key={i}>
      {line}
      <br />
    </span>
  ))

export function ChatLine({ who = 'bot', message }) {
  if (!message) {
    return null
  }
  const formatteMessage = convertNewLines(message)

  return (
    <div
      className={
        who != 'bot'
          ? 'float-right clear-both w-full flex justify-center'
          : 'float-left clear-both w-full flex justify-center'
      }
    >
      <div className="float-right lg:w-[629px] w-full lg:px-[18px] py-2 lg:py-[13px] bg-zinc-900 bg-opacity-60 rounded-xl border border-zinc-900 backdrop-blur-[30px] flex-col justify-start items-start gap-2.5 inline-flex mt-6">
        <div className="flex space-x- w-full">
          <div className="flex gap-5 w-full">
            <div className="flex item-start">
              {who == 'bot' ? (
                <img
                  height={1000}
                  width={1000}
                  className="w-10 h-10 relative rounded-full bg-black mr-2 sm:mr-0"
                  src="/chatbot.png"
                />
              ) : (
                ''
              )}
            </div>
            <BalancerWrapper>
              <p className="text-left text-white text-xl font-semibold  leading-normal">
                <a href="#" className="hover:underline">
                  {who == 'bot' ? 'Annalese (AI)' : 'You'}
                </a>
              </p>
              <p
                className={clsx(
                  ' text-[#98A2B3] text-md font-normal  leading-snug tracking-tight',
                  who == 'bot' ? 'font-normal ' : 'text-gray-200',
                )}
              >
                {formatteMessage}
              </p>
            </BalancerWrapper>
          </div>
        </div>
      </div>
    </div>
  )
}
